const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  feedNav: state => state.user.feedNav,
  EncodeUserInfo: state => state.user.EncodeUserInfo,
  menus: state => state.app.menus,
  activeIndex: state => state.app.activeIndex,
  top_bg: state => state.app.top_bg
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js